export default __webpack_public_path__ + "static/media/894.f0d256d5.gif";